/**
 * Animal detail-field discriminator and the API field names that map to each.
 * Used by `AnimalDetailFields` to dispatch between renderers.
 */

/** Render-type tag returned by `getFieldValue` and consumed by the renderer switch. */
export const ANIMAL_FIELD_TYPE = {
  TEXT: 'text',
  DATE: 'date',
  SEX: 'sex',
  REGISTRATION_STATUS: 'registrationStatus',
  ANIMAL_STATUS: 'animalStatus',
  SIRE: 'sire',
  DAM: 'dam',
  BREEDER: 'breeder',
  OWNER: 'owner',
} as const;

/** Lower-cased field names accepted by `getFieldValue` (mapped from API field). */
export const ANIMAL_FIELD_NAME = {
  ANIMAL_NAME: 'animalname',
  NAME: 'name',
  ANIMAL_IDENT: 'animalident',
  REGISTRATION_STATUS: 'registrationstatus',
  ANIMAL_STATUS: 'animalstatus',
  DATE_OF_BIRTH: 'dateofbirth',
  SEX: 'sex',
  GENDER: 'gender',
  SIRE: 'sire',
  DAM: 'dam',
  BREEDER: 'breeder',
  OWNER: 'owner',
  CURRENT_OWNER: 'currentowner',
  TATTOO: 'tattoo',
  ANIMAL_TATTOO: 'animaltattoo',
} as const;
